import React, { useEffect, useState } from 'react'
import TermsText from '../TermsText'

const BookingConfirmationFooter = () => {
  const { configuration, dictionary } = window.bookingConfirmationFooterData

  const handleNewBooking = () => {
    window.location.href = '/'
  }

  return (
    <div className="s-booking-confirmation__buttons">
      <button
        type="button"
        className="btn btn-primary"
        onClick={handleNewBooking}>
        {configuration.confirmationPageType === 'booking'
          ? dictionary.makeNewBookingButtonLabel
          : dictionary.returnToHomeButtonLabel}
      </button>
      <button type="button" className="btn btn-link">
        <TermsText endpoint={configuration.endpointTermsNConditions} />
      </button>
    </div>
  )
}

export default BookingConfirmationFooter
